import * as Yup from 'yup';

export default Yup.object({
  surname: Yup.string()
    .max(100, 'Must be 100 characters or less')
    .required('Please enter your surname'),
  firstNames: Yup.string()
    .max(100, 'Must be 100 characters or less')
    .required('Please enter your first name'),
  company: Yup.string().max(100, 'Must be 100 characters or less'),
  carRegistration: Yup.string().max(10, 'Must be 10 characters or less'),
  emailAddress: Yup.string().email(),
  mobile: Yup.string().max(20, 'Must be 20 characters or less'),
  host: Yup.string()
    .max(100, 'Must be 100 characters or less')
    .required('Please enter the name of the person that you are here to see'),
});
